import { SQS, Credentials } from 'aws-sdk';
const EMAILS_QUEUE = process.env.SRV_EMAILS_QUEUE_URL;
const ACCESS_KEY_ID = process.env.SRV_EMAILS_ACCESS_KEY_ID;
const ACCESS_KEY_SECRET = process.env.SRV_EMAILS_SECRET_KEY;
const sqs = new SQS({
    region: 'eu-west-1',
    credentials: new Credentials({
        accessKeyId: ACCESS_KEY_ID,
        secretAccessKey: ACCESS_KEY_SECRET
    })
});
export const enqueue = (email) => {
    return sqs
        .sendMessageBatch({
        QueueUrl: EMAILS_QUEUE,
        Entries: [
            {
                Id: new Date().getTime().toString(),
                MessageGroupId: 'email',
                MessageDeduplicationId: email.deduplicationId ?? new Date().getTime().toString(),
                MessageBody: JSON.stringify(email)
            }
        ]
    })
        .promise();
};
